export const ACCOUNT_INFO = "/login/user";
